import React, { useEffect } from "react";
import styles from "./style.module.scss";
import { Chart as ChartJS } from "chart.js";
import LapTimePlot from "./LapTimePlot";
import LoopTimePlot from "./LoopTimePlot";

function Plots() {
  useEffect(() => {
    ChartJS.defaults.font.family = getComputedStyle(document.body).fontFamily;
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.plot}>
        <LapTimePlot />
      </div>
      <div className={styles.plot}>
        <LoopTimePlot />
      </div>
    </div>
  );
}

export default Plots;
